import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginPageComponent } from './login.component';

export const LoginRoutes: ModuleWithProviders<RouterModule> = RouterModule.forChild([
  { path: 'login', component: LoginPageComponent }
]);
